import { useEffect, useState } from 'react'
import { NoRecords, PageLoader } from '../../lib/loader'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useUpdateCms } from './api/cmsapi';
import { Edit } from 'lucide-react';
import Cms from './tabs/cms';
import { Modal, ModalBody } from 'reactstrap';
import moment from 'moment';
import useConfirm from '../../hooks/useConfirm';
import { useGetCardCms } from '../Homepage-Management/api/homepageApi';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { CircularProgress } from '@mui/material';
import { useToast } from '../../hooks/usetoast';
import { queryClient } from '../../config';



const urlRegex = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9@:%._+~#=-]{2,256}\.[a-z]{2,6}\b([a-zA-Z0-9@:%_+.~#?&//=]*)$/;

const schema = yup.object().shape({
    url: yup
        .string()
        .required("Enter URL Address")
        .matches(urlRegex, "Enter a valid URL address "),
    linkTitle: yup.string().required('linkTitle'),
});

function CardManagement() {

    const [editdata, setEditdata] = useState();
    const [open, setOpen] = useState(false)
    const toggle = () => setOpen(!open)
    const toast = useToast()

    const { data: getCms, isLoading } = useGetCardCms()
    const updateCms = useUpdateCms();


    const filteredCms = getCms?.data?.data;

    const [Dialog] = useConfirm()

    const [isedit, setIsedit] = useState(false)
    const toggleEdit = () => {
        setIsedit(!isedit)
    }


    const handleEdit = (item, type) => {
        if (type == "content") {
            toggleEdit()
        } else {
            toggle()
        }
        setEditdata(item);
    }




    const { control, handleSubmit, formState: { errors }, reset } = useForm({
        mode: 'onChange',
        resolver: yupResolver(schema),
        defaultValues: {
            url: editdata?.externalLink,
            linkTitle: editdata?.linkTitle
        }
    })

    useEffect(() => {
        if (editdata?.externalLink) {

            reset({

                url: editdata.externalLink || "",
                linkTitle: editdata.linkTitle || "",
            });
        }
    }, [editdata, reset]);
    const onSubmit = async (data) => {
        const formData = new FormData();
        formData.append("id", editdata?._id);
        formData.append("image", editdata.image ? editdata.image : '');
        formData.append("content", editdata.content != 'undefined' ? editdata.content : '');
        formData.append("externalLink", data.url);
        formData.append("linkTitle", data.linkTitle);


        let res = await updateCms.mutateAsync(formData)
        if (!res?.data?.status) {

            toast.error(res?.data?.message)
        }
        else {
            toast.success(res?.data?.message)

        }
        reset()
        toggle();
        queryClient.refetchQueries("cms");

    }
    let content;

    if (filteredCms?.length > 0) {
        content = (

            <div style={{ minHeight: "60vh" }}>
                <div className='table-responsive'>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ maxWidth: "60px" }} align='center'>
                                    S.NO
                                </TableCell>
                                <TableCell>Title</TableCell>
                                <TableCell>Last updated Date & Time </TableCell>
                                <TableCell align='center'>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredCms?.map((row, i) => (
                                <TableRow key={row.id || i}>
                                    <TableCell align='center'>{(i + 1)}</TableCell>
                                    <TableCell>{row.linkTitle}</TableCell>

                                    <TableCell>{moment(row.updatedAt).format("DD/MM/YYYY | hh:mm A")}</TableCell>
                                    <TableCell align='center'>
                                        <div className='d-flex justify-content-center'>
                                            <Edit className="mx-3" size={20} type='button' onClick={() => handleEdit(row, (!row.content || row.content == 'undefined' || row.content == '' || row.content == null) ? "url" : "content")} />

                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </div>

        );
    } else {
        content = <NoRecords />;
    }


    return (

        <section>
            {updateCms.isLoading && <PageLoader />}
            <h4>Card Agreement Management</h4>
            <br />
            <br />
            <div className="ad_pg_bx bg-white p-3">
                {isLoading ?
                    <PageLoader />
                    :
                    content
                }
            </div>
            <Dialog />

            <Modal isOpen={isedit} toggle={toggleEdit} centered>
                <div className="modal-header">
                    <h4 className="modal-title fs-11">{editdata?.heading}</h4>
                    <button type="button" className="btn-close" onClick={toggleEdit} aria-label="Close">
                        <img src={require('../../assets/images/icons/close-circle.svg').default} alt="close-circle" />
                    </button>
                </div>
                <ModalBody>
                    <Cms editData={editdata} toggleEdit={toggleEdit} />
                </ModalBody>
            </Modal>

            <Modal isOpen={open} toggle={toggle} centered>
                <div className="modal-header">
                    <h1 className="modal-title fs-5">{editdata?.heading}</h1>
                    <button type="button" className="btn-close" onClick={toggle} aria-label="Close">
                        <img src={require('../../assets/images/icons/close-circle.svg').default} alt="close-circle" />
                    </button>
                </div>
                <ModalBody>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className='mb-3'>
                            <h6 className="pb-2">Title</h6>
                            <Controller
                                control={control}
                                name="linkTitle"
                                render={({ field }) => (
                                    <input
                                        {...field}
                                        placeholder="Enter Title"
                                        className={errors?.linkTitle ? 'form-control is-invalid' : 'form-control'}
                                    />
                                )}
                            />
                            {errors?.linkTitle?.message && <p className='m-0 errMsg'>{errors?.linkTitle?.message}</p>}
                        </div>
                        <div className='mb-3'>
                            <h6 className="pb-2">Edit Url</h6>
                            <Controller
                                control={control}
                                name="url"
                                render={({ field }) => (
                                    <input
                                        {...field}
                                        placeholder="Enter URL"
                                        className={errors?.url ? 'form-control is-invalid' : 'form-control'}
                                    />
                                )}
                            />
                            {errors?.url?.message && <p className='m-0 errMsg'>{errors?.url?.message}</p>}
                        </div>
                        <div className='d-flex justify-content-center rounded-pill'>
                            <button className='btn btn-primary d-flex align-items-center' disabled={updateCms.isLoading}>
                                {updateCms.isLoading ?
                                    <CircularProgress size={20} style={{ color: "#fff" }} className='mx-4' />
                                    :
                                    "Submit"}
                            </button>
                        </div>
                    </form>
                </ModalBody>
            </Modal>
        </section>
    )
}


export default CardManagement